export function getRootLevel(children) {
  return {
    refId: null,
    children,
  };
}

export function getParentLevel({ levels, flatLevels, refId, steps }) {
  const level = flatLevels[refId];
  if (level.parentRefId) {
    if (steps === 1) {
      return flatLevels[level.parentRefId];
    }
    return getParentLevel({
      levels,
      flatLevels,
      refId: level.parentRefId,
      steps: steps - 1,
    });
  }
  return getRootLevel(levels);
}

const getFormattedLevel = (level, order) => ({
  refId: level.refId,
  value: level.value,
  order,
});

export function getOrderedSelectedLevels(levels, answerRefId) {
  for (let i = 0; i < levels.length; i += 1) {
    const level = levels[i];
    if (level.answerRefId === answerRefId) {
      return [getFormattedLevel(level, i)];
    }
    if (level.children) {
      const result = getOrderedSelectedLevels(level.children, answerRefId);
      if (result.length > 0) {
        return [getFormattedLevel(level, i), ...result];
      }
    }
  }
  return [];
}
